import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../lib/AuthContext'

export default function ResetPassword() {
  const [password, setPassword] = useState('')
  const [confirm, setConfirm] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const [success, setSuccess] = useState('')
  const { updatePassword } = useAuth()
  const navigate = useNavigate()

  const handleReset = async () => {
    if (password !== confirm) return setError('Passwords do not match')
    if (password.length < 6) return setError('Password must be at least 6 characters')
    setLoading(true); setError('')
    const { error } = await updatePassword(password)
    if (error) setError(error.message)
    else { setSuccess('Password updated!'); setTimeout(() => navigate('/dashboard'), 2000) }
    setLoading(false)
  }

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
      <div style={{ background: 'var(--card)', border: '1px solid var(--border)', borderRadius: 16, padding: '32px 28px', width: '100%', maxWidth: 400 }}>
        <h2 style={{ fontFamily: "'Bebas Neue', cursive", fontSize: 32, letterSpacing: 1, marginBottom: 8 }}>New Password</h2>
        <p style={{ color: 'var(--grey)', fontSize: 14, marginBottom: 24 }}>Choose a new password for your account.</p>
        {error && <div className="error-msg">{error}</div>}
        {success && <div className="success-msg">{success}</div>}
        <div className="form-group">
          <label className="form-label">New Password</label>
          <input className="form-input" type="password" placeholder="Min. 6 characters" value={password} onChange={e => setPassword(e.target.value)} />
        </div>
        <div className="form-group">
          <label className="form-label">Confirm Password</label>
          <input className="form-input" type="password" placeholder="Repeat password" value={confirm} onChange={e => setConfirm(e.target.value)} />
        </div>
        <button className="btn-primary" onClick={handleReset} disabled={loading}>{loading ? 'Updating...' : 'Update Password'}</button>
      </div>
    </div>
  )
}
